import { reduxStoreTypes } from '@/type/redux-store';


export const SET_COLLAPSED: reduxStoreTypes.collapsedType = 'SET_COLLAPSED';
export const setCollapsed = (params: Omit<reduxStoreTypes.collapsedAction, 'type'>) => ({
    type: SET_COLLAPSED,
    ...params
})